/* Land of Legends landing — shared behaviour: scroll-reveal, sticky anchor nav,
   mobile booking bar, smooth-scroll to the booking hero. Tiny, no deps. */
(function () {
  'use strict';
  if (window.__lotlLanding) return;
  window.__lotlLanding = true;

  // --- scroll reveal ---
  function initReveal() {
    var els = document.querySelectorAll('.lotl-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  // --- smooth scroll to the booking hero (any [data-lotl-scroll] / hash to #lotl-book) ---
  function scrollToBooking() {
    var target = document.querySelector('[data-lotl-booking]') || document.getElementById('lotl-book');
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: top, behavior: 'smooth' });
    var input = target.querySelector('[data-hotel-input]');
    if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, 600);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-lotl-scroll]');
    if (t) { e.preventDefault(); scrollToBooking(); }
  });

  // --- sticky anchor nav: smooth scroll + accurate active state ---
  // Mirrors the categories-pill pattern (assets/category.js): a SINGLE smooth
  // scroll per click (no re-scroll loop = no jiggle), an IntersectionObserver
  // for the active state, and the active tab is kept in view by moving ONLY the
  // nav strip's own scrollbar — never the page.
  function initAnchorNav() {
    var nav = document.querySelector('[data-lotl-nav]');
    if (!nav) return;
    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    var sections = links.map(function (l) { return document.querySelector(l.getAttribute('href')); }).filter(Boolean);
    var hero = document.querySelector('[data-lotl-booking]');
    var navScroller = nav.querySelector('.lotl-nav__links');
    var HEADER_OFFSET = 84;          // clears the stuck nav bar
    var clickLock = false, lockTimer = null;

    sections.forEach(function (s) { s.style.scrollMarginTop = HEADER_OFFSET + 'px'; });

    // Center the active tab by scrolling the nav strip only (never the page).
    function centerNavLink(link) {
      if (!navScroller) return;
      if (navScroller.scrollWidth <= navScroller.clientWidth + 10) return;
      var pos = link.offsetLeft - (navScroller.clientWidth / 2) + (link.clientWidth / 2);
      navScroller.scrollTo({ left: Math.max(0, pos), behavior: 'smooth' });
    }

    function setActive(id) {
      links.forEach(function (l) {
        var on = l.getAttribute('href') === '#' + id;
        l.classList.toggle('is-active', on);
        if (on) centerNavLink(l);
      });
    }

    // Reveal the sticky nav once the booking hero is scrolled past.
    function onScrollStuck() {
      var bottom = hero ? hero.getBoundingClientRect().bottom : 400;
      nav.classList.toggle('is-stuck', bottom < 0);
    }
    window.addEventListener('scroll', onScrollStuck, { passive: true });
    onScrollStuck();

    // Active-state detection — paused while a click-scroll is running so the
    // observer can't fight it (the source of the inaccurate highlight before).
    var io = new IntersectionObserver(function () {
      if (clickLock || window.innerWidth < 750) return;
      var vh = window.innerHeight, topB = vh * 0.2, botB = vh * 0.5, current = null;
      sections.forEach(function (s) {
        var r = s.getBoundingClientRect();
        if (r.top < botB && r.bottom > topB) current = s.id;
      });
      if (current) setActive(current);
    }, { root: null, rootMargin: '-20% 0px -50% 0px', threshold: 0 });
    sections.forEach(function (s) { io.observe(s); });

    links.forEach(function (l) {
      l.addEventListener('click', function (e) {
        var tgt = document.querySelector(l.getAttribute('href'));
        if (!tgt) return;
        e.preventDefault();

        clickLock = true;            // freeze the observer during the scroll
        clearTimeout(lockTimer);
        setActive(tgt.id);           // highlight responds instantly to the click

        var top = tgt.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });

        // ONE-SHOT drift correction (not a loop): lazy media above can shift the
        // target during the scroll. A single re-align keeps it accurate, no jiggle.
        lockTimer = setTimeout(function () {
          var want = tgt.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
          if (Math.abs(window.pageYOffset - want) > 6) {
            window.scrollTo({ top: Math.max(0, want), behavior: 'smooth' });
            lockTimer = setTimeout(function () { clickLock = false; }, 450);
          } else {
            clickLock = false;
          }
        }, 600);
      });
    });
  }

  // --- mobile booking bar: hide while the hero/footer is in view ---
  function initBookingBar() {
    var bar = document.querySelector('[data-lotl-bar]');
    if (!bar) return;
    var hero = document.querySelector('[data-lotl-booking]');
    function onScroll() {
      var heroVisible = hero && hero.getBoundingClientRect().bottom > 80;
      bar.classList.toggle('is-show', !heroVisible && window.pageYOffset > 500);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // --- FAQ accordion: native <details> kept for SEO/a11y, but the panel height
  //     is animated so open/close glides. Interruptible: clicking mid-animation
  //     reverses smoothly from the current height (no blocking, never "stuck"). ---
  function initFaqAccordion() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var DUR = 300;
    Array.prototype.slice.call(document.querySelectorAll('.lotl-faq__item')).forEach(function (item) {
      if (item.__faqInit) return;
      item.__faqInit = true;
      var summary = item.querySelector('.lotl-faq__q');
      var panel = item.querySelector('.lotl-faq__a');
      if (!summary || !panel) return;

      var endTimer = null;

      function clearInline() {
        panel.style.transition = '';
        panel.style.height = '';
        panel.style.overflow = '';
      }

      // Animate height from -> to. `done` runs once the motion settles.
      function animate(from, to, done) {
        if (endTimer) { clearTimeout(endTimer); endTimer = null; }
        panel.style.overflow = 'hidden';
        panel.style.transition = 'none';
        panel.style.height = from + 'px';
        // Two frames: commit the start height, THEN enable the transition and
        // set the target — the most reliable way to trigger a height animation.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            panel.style.transition = 'height ' + DUR + 'ms ease';
            panel.style.height = to + 'px';
          });
        });
        endTimer = setTimeout(function () {
          endTimer = null;
          clearInline();
          if (done) done();
        }, DUR + 40);
      }

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        // `is-open` reflects intent immediately (item.open lags until close ends),
        // so it's the reliable state for deciding direction + interruption.
        var current = panel.offsetHeight; // live height, even mid-animation
        if (item.classList.contains('is-open')) {
          // CLOSE
          item.classList.remove('is-open');
          if (reduce) { clearInline(); item.open = false; return; }
          animate(current, 0, function () { item.open = false; });
        } else {
          // OPEN
          item.open = true;            // reveal so we can measure full height
          item.classList.add('is-open');
          if (reduce) { clearInline(); return; }
          panel.style.height = 'auto';
          var target = panel.scrollHeight;
          animate(current, target);
        }
      });
    });
  }

  function init() { initReveal(); initAnchorNav(); initBookingBar(); initFaqAccordion(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-init the accordion when the section is added/edited in the theme editor.
  document.addEventListener('shopify:section:load', function () { initFaqAccordion(); });
})();
